import { useEffect } from 'react';
import type { ThemeFont } from '@/lib/profileTheme';

/**
 * Injects @font-face declarations for theme fonts into the document head.
 * Font family names and URLs are already sanitized by parseProfileTheme.
 */
export function FontLoader({ fonts }: { fonts: (ThemeFont | undefined)[] }) {
  useEffect(() => {
    const loaded: FontFace[] = [];

    for (const font of fonts) {
      if (!font?.url || !font.family) continue;
      try {
        const face = new FontFace(font.family, `url(${JSON.stringify(font.url)})`);
        face.load().then((loadedFace) => {
          document.fonts.add(loadedFace);
        }).catch(() => {
          // Ignore fonts that fail to load; the fallback stack handles it.
        });
        loaded.push(face);
      } catch {
        // Invalid font descriptor; skip.
      }
    }

    return () => {
      for (const face of loaded) {
        try {
          document.fonts.delete(face);
        } catch {
          // no-op
        }
      }
    };
  }, [fonts]);

  return null;
}
